module.exports = {
    "copyright": {
        "link": function(params) {
            return ["ООО «", params["content"], "»"];
        },
        "yandex": "ЯНДЕКС"
    }
};